package com.hyperether.goodjob.util

enum class DocumentType {
    JOB_FILE,
    JOB_IMAGE,
    JOB_PDF,
    REPORT_FILE,
    REPORT_FILE_IMAGE,
    REPORT_FILE_PDF,
    REPORT_SIGNATURE,
    REPORT_SIGNATURE_IMAGE,
    REPORT_SIGNATURE_PDF
}

fun DocumentType?.isSignature(): Boolean =
    this in setOf(
        DocumentType.REPORT_SIGNATURE,
        DocumentType.REPORT_SIGNATURE_IMAGE,
        DocumentType.REPORT_SIGNATURE_PDF
    )
